import { Card } from "../../../components/card.component";
import { useCallback, useEffect, useState } from "react";
import searchIcon from "../../../assets/img/search-icon.svg";
import {
  ActionsUsersTable,
  useAppDispatch,
  useAppSelector,
} from "../../../core/redux";
import { UsersList } from "../../../features/users/usersList.component";
import { ExportButton } from "../../../components/export.component";
import { debounce } from "../../../utils";

export const PageUsersView = () => {
  const dispatch = useAppDispatch();
  const { pageNumber, pageSize, searchKey } = useAppSelector(
    (state) => state.usersTable
  );
  const [tempSearchKey, setTempSearchKey] = useState(searchKey);

  const searchUsersList = useCallback(
    (ev: React.ChangeEvent<HTMLInputElement>): void => {
      setTempSearchKey(ev.target.value);
      debounce(() => {
        dispatch(ActionsUsersTable.goToPage(1));
        dispatch(ActionsUsersTable.setSearchKey(ev.target.value));
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    return () => {
      dispatch(ActionsUsersTable.resetData());
    };
  }, [dispatch]);

  return (
    <Card
      header={
        <div className="row align-items-center  justify-content-between">
          <div className="col-md-8 col-12 content-box-title">
            <div>
              <p className="text-capitalize my-1 text-green-200">
                Manage Users List
              </p>
            </div>
            <div className="collapse-icon"></div>
          </div>
          <div className="col-md-4 col-12 mt-1">
            <form className="search-component">
              <div className="input-group me-3">
                <span
                  className="input-group-text pe-2"
                  id="search-component-word"
                >
                  <img src={searchIcon} alt="search-icon" />
                </span>
                <input
                  type="text"
                  className="form-control ps-0"
                  placeholder="Search..."
                  aria-label="Search"
                  aria-describedby="search-component-word"
                  onChange={searchUsersList}
                  value={tempSearchKey}
                  onKeyPress={(ev) => {
                    ev.key === "Enter" && ev.preventDefault();
                  }}
                />
                {tempSearchKey.length > 0 && (
                  <span
                    className="input-group-text text-green-200"
                    id="search-component-word"
                  >
                    <i
                      className="fas fa-times click"
                      onClick={() => {
                        setTempSearchKey("");
                        dispatch(ActionsUsersTable.setSearchKey(""));
                      }}
                    />
                  </span>
                )}
              </div>
              <ExportButton
                params={{ pageNumber, pageSize, searchKey }}
                component="Users"
              />
            </form>
          </div>
        </div>
      }
    >
      <UsersList />
    </Card>
  );
};
